<template>
	<div class="pollutionalertsFormHeader puiformheader">
		<v-row>
			<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
				<pui-field :label="$t('header.pollutionalerts.pollutionid')" :value="getPollutionIdValue"></pui-field>
			</v-col>
			<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
				<pui-field :label="$t('header.pollutionalerts.tier')" :value="getTierValue"></pui-field>
			</v-col>
			<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
				<pui-field :label="$t('header.pollutionalerts.date')" :value="getFormattedUploaddate"></pui-field>
			</v-col>
			<v-col class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
				<pui-field :label="$t('header.pollutionalerts.statusid')" :value="getStatusIdValue"></pui-field>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'pollutionalerts-form-header-modal',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'pollutionalerts'
		};
	},
	computed: {
		getPollutionIdValue() {
			return this.model && this.model.pollutionid ? this.model.pollutionid : '-';
		},
		getStatusIdValue() {
			return this.model && this.model.statuscode && this.model.statuscode == 'O' ? 'Open' : 'Closed';
		},
		getTierValue() {
			return this.model && this.model.tierdesc ? this.model.tierdesc : '-';
		},
		getFormattedUploaddate() {
			if (this.model && this.model.incidentdate) {
				const dateformat = new Date(this.model.incidentdate);
				const formattedDate = `${dateformat.toLocaleDateString()} ${dateformat.toLocaleTimeString()}`;
				return formattedDate;
			} else {
				return '-';
			}
		}
	}
};
</script>
